import React from 'react';
import { cn } from '@/utils';

interface HeatmapBarProps {
  hour: number;
  count: number;
  maxCount: number;
  colorClass: string;
}

export const HeatmapBar: React.FC<HeatmapBarProps> = ({
  hour,
  count,
  maxCount,
  colorClass,
}) => {
  const percentage = maxCount > 0 ? (count / maxCount) * 100 : 0;

  return (
    <div className='flex flex-col h-full group relative'>
      <div className='mb-2 text-center'>
        <span
          className={cn(
            'text-sm font-black transition-all duration-300',
            count > 0 ? 'text-slate-900 scale-110' : 'text-slate-300'
          )}
        >
          {count > 0 ? count : ''}
        </span>
      </div>

      <div
        className={cn(
          'flex-1 rounded-lg flex flex-col justify-end border-2 transition-all hover:scale-105 hover:shadow-xl cursor-pointer relative overflow-hidden',
          colorClass
        )}
      >
        <div
          className='w-full bg-white/40 backdrop-blur-[1px] transition-all duration-1000 ease-out'
          style={{ height: `${percentage}%` }}
        />
      </div>

      <div className='absolute -top-8 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-[10px] font-bold px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-20 shadow-xl'>
        {count} tickets a las {hour}h
      </div>
    </div>
  );
};
